import cls from "@fvilers/cls";
import { ComponentPropsWithRef } from "react";
import styles from "./FieldError.module.css";

type FieldErrorProps = {
  errors?: string | string[] | null;
} & Omit<ComponentPropsWithRef<"ul">, "children">;

export function FieldError({ className, errors, ...props }: FieldErrorProps) {
  if (!errors) {
    return null;
  }
  const normalized = Array.isArray(errors) ? errors : [errors];

  return (
    <ul
      className={cls(styles.FieldError, className)}
      data-slot="error"
      {...props}
    >
      {normalized.map((error, index) => (
        <li key={index}>{error}</li>
      ))}
    </ul>
  );
}

export function FormError({ className, ...props }: FieldErrorProps) {
  return <FieldError className={cls(styles.FormError, className)} {...props} />;
}
